import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { matchPath } from "react-router";
import TopMenuComponent from "./TopMenuComponent";
import TopCartComponent from "./TopCartComponent";

class TopNavComponent extends Component{
    handleGoBack = () => {
        return this.props.history.length > 2 ? this.props.history.goBack() : this.props.history.push(`${process.env.PUBLIC_URL}/`)
    }

    render() {
        let title = '';
        if (matchPath(this.props.location.pathname, {
            path: ["/home/vendors","/home/vendors/"],
            exact: true,
            strict: true
        }))
            title = 'Pick Your Vendor';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/search","/home/search/"],
            exact: true,
            strict: true
        }))
            title = 'Search';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/profile","/home/profile/"],
            exact: true,
            strict: true
        }))
            title = 'Profile Info';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/edit-profile","/home/edit-profile/"],
            exact: true,
            strict: true
        }))
            title = 'Edit Profile';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/help","/home/help/"],
            exact: true,
            strict: true
        }))
            title = 'Help';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/settings","/home/settings/"],
            exact: true,
            strict: true
        }))
            title = 'Settings';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/change-password","/home/change-password/"],
            exact: true,
            strict: true
        }))
            title = 'Change Password';
        else if (matchPath(this.props.location.pathname, {
            path: "/home/select-category/:id",
            exact: true,
            strict: true
        }))
            title = 'Pick Your Deal Type';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/cart/purchased/allday/:id","/home/cart/purchased/oneday/:id"],
            exact: true,
            strict: true
        }))
            title = 'Purchased cart deals';
        else if (matchPath(this.props.location.pathname, {
            path: "/home/vendor/reviews/:id",
            exact: true,
            strict: true
        }))
            title = 'Review & Ratings';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/following","/home/following/"],
            exact: true,
            strict: true
        }))
            title = 'Following';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/favorites","/home/favorites/"],
            exact: true,
            strict: true
        }))
            title = 'Favorites';
        else if (matchPath(this.props.location.pathname, {
            path: "/home/reviews/rated/:id",
            exact: true,
            strict: true
        }))
            title = 'Previously Rated';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/cart/purchased","/home/cart/purchased/"],
            exact: true,
            strict: true
        }))
            title = 'Purchased Cart Deals';
        else if (matchPath(this.props.location.pathname, {
            path: "/home/reviews/pending/:id",
            exact: true,
            strict: true
        }))
            title = 'Pending';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/cart","/home/cart/"],
            exact: true,
            strict: true
        }))
            title = 'My Cart';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/refer","/home/refer/"],
            exact: true,
            strict: true
        }))
            title = 'Refer us to a friend';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/allday/entry-pass/:id","/home/oneday/entry-pass/:id"],
            exact: true,
            strict: true
        }))
            title = 'Entry Pass';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/allday/my-purchased-deals","/home/allday/my-purchased-deals/"],
            exact: true,
            strict: true
        }))
            title = 'My Purchased Per Person Deals';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/oneday/my-purchased-deals","/home/oneday/my-purchased-deals/"],
            exact: true,
            strict: true
        }))
            title = 'My Purchased Group Deals';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/reviews/pending","/home/reviews/pending/","/home/reviews/rated","/home/reviews/rated/"],
            exact: true,
            strict: true
        }))
            title = 'Review & Ratings';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/allday/shared-deals","/home/allday/shared-deals/","/home/oneday/shared-deals","/home/oneday/shared-deals/"],
            exact: true,
            strict: true
        }))
            title = 'Associate Host Services';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/allday/shared-deal/:id","/home/oneday/shared-deal/:id"],
            exact: true,
            strict: true
        }))
            title = 'Deal Details';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/allday/deal/:id","/home/oneday/deal/:id"],
            exact: true,
            strict: true
        }))
            title = 'Deal Details';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/category/allday/view-all","/home/category/allday/view-all/","/home/category/oneday/view-all","/home/category/oneday/view-all/","/home/category/allday/view-all/:id","/home/category/oneday/view-all/:id","/home/allday/category-deals","/home/allday/category-deals/","/home/oneday/category-deals","/home/oneday/category-deals/"],
            exact: true,
            strict: true
        }))
            title = 'Pick Your Deal';
        else if (matchPath(this.props.location.pathname, {
            path: ["/home/oneday/payment/:id", "/home/allday/payment/:id", "/home/cart/payment","/home/cart/payment/"],
            exact: true,
            strict: true
        }))
            title = 'Payment';

        return (
            <div className="inner-navbar">
                <div className="container">

                    <div className="inner-navbar-fit">
                        <button onClick={this.handleGoBack} className="arrow-left"><i className="fa fa-chevron-left d-none"
                                                          aria-hidden="true"></i><img
                            src={`${process.env.PUBLIC_URL}/image/back_white.png`} alt=""/>
                        </button>
                        <h1 className="text-hide">
                            <Link to={`${process.env.PUBLIC_URL}/`} className="logo-link logo-replacement"
                                  style={{backgroundImage: "url('" + process.env.PUBLIC_URL + "/image/silverback-logo-text.png')"}}></Link>
                            Host4VIP
                        </h1>
                        <h4 className="banner-choose-deal-heading">{title}</h4>
                        <div className="d-flex align-items-center">

                            <TopMenuComponent/>

                            <TopCartComponent/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TopNavComponent;